const copyToClipboard = async (text: string, onSuccess: () => void) => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
        } else {
            // Fallback for Safari and older mobile browsers
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        }
        onSuccess(); // Callback to handle success state
    } catch (err) {
        console.error("Failed to copy:", err);
    }
};

export default copyToClipboard;